module.exports = __webpack_public_path__ + "static/media/TrophyTie.604d5085.svg";